function matchesMediaQuery(breakpointName) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).matches;
}
function mediaQueryListener(breakpointName, func) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).addEventListener("change", func);
}
function ValidateEmail(inputText) {
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (inputText.value.match(mailformat)) {
    return true;
  } else {
    return false;
  }
}

function loadSizeMarket() {
  if (document.querySelector("[data-size=" + window.localization.size_market + "]")) {
    document.querySelector("[data-size=" + window.localization.size_market + "]").click();
  }
}

class SizeConverterComponent extends HTMLElement {
  constructor() {
    super();
    this.handleGenderChange = this.handleGenderChange.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.linkedColors = document.querySelectorAll('.thumbnail-swatch');
  }

  connectedCallback() {
    // set default to us if there is privacy issues with localization
    this.currentMarket = window.localization?.size_market || 'US';
    this.currentMarket = window.localization?.size_market || 'default_size';
    document.addEventListener("gender:change", this.handleGenderChange);
    document.addEventListener("variant:change", this.handleVariantChange);
    this.addEventListener('click', this.handleClick);
    this.initializeSizeSwitching();
    this.updateActiveSizeOnLoad();
  }

  disconnectedCallback() {
    document.removeEventListener("gender:change", this.handleGenderChange);
    document.removeEventListener("variant:change", this.handleVariantChange);
    this.removeEventListener('click', this.handleClick);
  }

  handleGenderChange(event) {
    if (!this.closest('facets-form')) {
      this.setAttribute('data-type', event.detail.swatch.innerText.toLowerCase());
    }
    document.querySelector('product-gallery').setAttribute('data-type', event.detail.swatch.innerText.toLowerCase());
    this.showSize(this.currentMarket);
  }

  handleVariantChange(event) {
    this.showSize(this.currentMarket);
  }

  handleClick(event) {
    const sizeSwitcher = event.target.closest('.nav--sizes');
    if (sizeSwitcher) {
      this.updateActiveSize(sizeSwitcher);
      this.currentMarket = sizeSwitcher.getAttribute('data-size');
      this.showSize(sizeSwitcher.getAttribute('data-size'));
    }
  }

  initializeSizeSwitching() {
    this.showSize(window.localization?.size_market || 'default_size');
  }

  updateActiveSizeOnLoad() {
    this.querySelectorAll('.nav--sizes').forEach((element) => {
      const storedSize = sessionStorage.getItem('sizeMarket');
      if (storedSize) {
      element.classList.remove('active');
      if(element.getAttribute('data-size') == storedSize) {
        element.classList.add('active');
        this.currentMarket = element.getAttribute('data-size');
        this.showSize(storedSize);
       }
      }
    });
  }
  updateActiveSize(activeElement) {
    this.querySelectorAll('.nav--sizes.active').forEach((element) => {
      element.classList.remove('active');
    });
    activeElement.classList.add('active');
    this.currentMarket = activeElement.getAttribute('data-size');
    sessionStorage.setItem('sizeMarket', this.currentMarket);
  }

  showSize(selectedSize) {
    let sizes_swatch;
    if (!this.closest('facets-form')) {
        sizes_swatch = document.querySelectorAll('.variant-picker .block-swatch-size');
    } else {
        sizes_swatch = document.querySelectorAll('.block-swatch-size');
    }
    if (!sizes_swatch) return;
    sizes_swatch.forEach((swatch) => {
      if(swatch.hasAttribute('data-original')){
      const currentSize = swatch.getAttribute('data-original');
      const replaceSize = currentSize.split('/');
      let sizeText = null;
      let display = 'none';

      if (replaceSize) {
        if (selectedSize === 'US') {
          if (this.getAttribute('data-type') === 'mens' && replaceSize.length >= 3 && replaceSize[0].includes('Mens')) {
            sizeText = replaceSize[0].split(' ')[2];
            display = 'flex';
          } else if (this.getAttribute('data-type') === 'womens' && replaceSize.length >= 3 && replaceSize[0].includes('Womens')) {
            sizeText = replaceSize[0].split(' ')[2];
            display = 'flex';
          } else if (replaceSize.length === 4) {
            if(this.getAttribute('data-type') === 'womens'){
            sizeText = replaceSize[1].split(' ')[3]; 
            }else{
            sizeText = replaceSize[0].split(' ')[2];
            }
            display = 'flex';
          }
        } else if (selectedSize === 'UK' || selectedSize === 'EU') {
          const isMens = this.getAttribute('data-type') === 'mens';
          const isWomens = this.getAttribute('data-type') === 'womens';
          const lastIndex = replaceSize.length - 1;
          const secondLastIndex = replaceSize.length - 2;

          let targetIndex = selectedSize === 'UK' ? secondLastIndex : lastIndex;

          if (isMens && replaceSize.length >= 3 && replaceSize[0].includes('Mens')) {
            sizeText = replaceSize[targetIndex].split(' ')[2];
            display = 'flex';
          } else if (isWomens && replaceSize.length >= 3 && replaceSize[0].includes('Womens')) {
            sizeText = replaceSize[targetIndex].split(' ')[2];
            display = 'flex';
          } else if (replaceSize.length === 4) {
            sizeText = replaceSize[targetIndex].split(' ')[2];
            display = 'flex';
          }
        }
      }

      swatch.style.display = display;
      if (swatch.previousElementSibling && swatch.previousElementSibling.checked && display === 'none') {
        const form = document.forms[this.getAttribute("form-id")];
        if (form) {
          const submitButton = form.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.innerText = 'Select size';
          }
        }
      }
      if (sizeText) {
        swatch.textContent = sizeText;
      }
    }
    });
  } 
}

// Register the custom element with the browser.
customElements.define('size-converter', SizeConverterComponent);

class GenderSwatch extends HTMLElement {
  constructor() {
    super();
    this.updateHistoryState = this.updateHistoryState.bind(this);
  }
  connectedCallback() {
    this.querySelectorAll('.button').forEach(swatch => {
      swatch.addEventListener('click', (event) => {
        // Remove 'is-active' class from all buttons
        this.querySelectorAll('.button').forEach(button => {
        button.classList.add('button--outline');
        });
        this.updateHistoryState(event.target);
        // Add 'is-active' class to the clicked button
        swatch.classList.remove('button--outline');
        // Dispatch custom event
        document.dispatchEvent(new CustomEvent("gender:change", { detail: { swatch } }));
      });
    });
    this.checkPreset();
  }
  updateHistoryState(event) {
      let gender = event.textContent.toLowerCase();
      let newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?sizesfor=").concat(gender);
      if (event) {
        let gender = event.textContent.toLowerCase();
        let newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?sizesfor=").concat(gender);
        window.history.replaceState({
          path: newUrl
        }, '', newUrl);
      } else if (window.location.search.includes('sizesfor')) {
        let searchParams = new URLSearchParams(window.location.search);
        let gender = searchParams.get('sizesfor');
        let newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?gender=").concat(gender);
        window.history.replaceState({
          path: newUrl
        }, '', newUrl);
      }
  }
  
  checkPreset() {
    var urlParam = window.location.search;
    let searchParams = new URLSearchParams(urlParam);
    if (searchParams.has('sizesfor') === true) {
      var search = searchParams.get('sizesfor');
      document.querySelectorAll('size-converter').forEach(element => {
        element.setAttribute('data-type', search); 
      });
      document.querySelector('product-gallery').setAttribute('data-type', search);
      this.querySelectorAll('.button').forEach(swatch => {
        if(swatch.textContent.toLowerCase() == search){
          // Dispatch a click event
          swatch.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          }));
        }
      });
    }else{
      if (this.closest('.quick-buy-modal')){
        var search = this.closest('.quick-buy-modal').getAttribute('data-preselect');
        this.closest('variant-picker').querySelector('size-converter').setAttribute('data-type', search);
        this.querySelectorAll('.button').forEach(swatch => {
          if(swatch.textContent.toLowerCase() == search){
            // Dispatch a click event
            swatch.dispatchEvent(new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            }));
          }
        });
      }
    }
  }
  }
  
  customElements.define('gender-size-switcher', GenderSwatch);



import {CountdownTimer} from 'theme';
class CountdownTimerSession extends CountdownTimer{
  constructor() {
    super();
  }

  // New method to update button text based on a new attribute
  recalculateFlips_fn = function() {
    const dateNow = /* @__PURE__ */ new Date();
    if (this, _expirationDate < dateNow) {
      if (this.getAttribute("expiration-behavior") === "hide") {
        this.closest(".shopify-section").remove();
      } else {
      }
    }
  };

}
if (!window.customElements.get("countdown-timer-session")) {
  window.customElements.define("countdown-timer-session", CountdownTimerSession);
}

document.addEventListener('product:rerender', function() {
  if (document.querySelector('notify-preorder')) {
    document.querySelectorAll('notify-preorder').forEach(element => {
      customElements.whenDefined('notify-preorder').then(() => {
        element.connectedCallback();
      });
    });
  }
});

class NotifyPreorder extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.backInStock = this.backInStock.bind(this);
    this.subscribeUser = this.subscribeUser.bind(this); 
  }

  connectedCallback() {
    this.loadUserSize();
    const notifyBackButton = this.querySelector('.notify-back');
    if (notifyBackButton) {
      notifyBackButton.addEventListener('click', (event) => this.backInStock(event));
    }
    document.addEventListener("variant:change", (event) => {
      this.handleVariantChange(event);
      this.updatePreorderState(event.detail.variant);
    });
  }

  disconnectedCallback() {

  }

  handleVariantChange = (event) => {
    this.updatePropertiesFromEvent(event);
    const backInStockElement = this.querySelector('.BackInStock');
    const notifyBackButton = this.querySelector('.notify-back');

    if (backInStockElement) {
      backInStockElement.classList.toggle('hidden', event.detail.variant.available);
      if (notifyBackButton) {
        notifyBackButton.removeEventListener('click', this.backInStock);
        if (!event.detail.variant.available) {
          notifyBackButton.addEventListener('click', this.backInStock);
        }
      }
    }
  }

  loadUserSize() {
    let size = sessionStorage.getItem('userShoeSize');
    if (size) {
      let variantInput = document.querySelector('variant-picker').querySelector(`input[value="${size}"]`);
      if (variantInput) {
        setTimeout(() => {
          variantInput.parentNode.querySelector('label').click();
        }, 500);
      }
    }
  }

  saveUserSize(event) {
    const shoeSize = event.detail.variant.option1;
    sessionStorage.setItem('userShoeSize', shoeSize);
  }

  updatePropertiesFromEvent(event) {
    if (event.detail.variant) {
      this.variantTitle = event.detail.variant.name;
      this.variantId = event.detail.variant.id;
    }
  }

  updatePropertiesFromJson(jsonData) {

    this.variantTitle = jsonData.selected_variant.name;
    this.variantId = jsonData.selected_variant.id;
  }

  updatePreorderState(newVariant) {
    var preorderData = {},
      $preorderMessage = document.getElementById("preOrderMessage"), 
      $preorderLineMessage = document.getElementById("PreOrderLine"),
      $addToCartButton = this.querySelector('button[type="submit"]');

    var preorderStockArr = this.querySelectorAll('.js-preorder-variant');

    for (var i = 0; i < preorderStockArr.length; ++i) {
      if (preorderStockArr[i].getAttribute('data-variantid') == newVariant.id) {
        var $wrapper = preorderStockArr[i],
          $variantsArr = $wrapper;
        var variant = $variantsArr,
          variantData = variant.dataset,
          variantId = variantData.variantid,
          variantAvailable = variantData.available,
          variantMessage = variantData.deliverymessage;

        preorderData[variantId] = {
          "available": variantAvailable,
          "deliverymessage": variantMessage
        }
      }
    }

    var variantData = preorderData[newVariant.id];
    if (variantData) {
      var isVariantAvailable = variantData.available,
        variantPreorderMessage = variantData.deliverymessage;
    }

    if (isVariantAvailable === 'true') {
      if (variantPreorderMessage && variantPreorderMessage != "") {
        $preorderMessage.innerHTML = window.themeVariables.strings.preOrderLabel + ': ' + variantPreorderMessage;
        $addToCartButton.innerHTML = "Add to cart";
        if (!$preorderLineMessage) {
          $preorderLineMessage = document.createElement('input');
          $preorderLineMessage.type = 'hidden';
          $preorderLineMessage.id = 'PreOrderLine';
          $preorderLineMessage.name = "properties[" + window.themeVariables.strings.preOrderLabel + "]";
          this.appendChild($preorderLineMessage);
        }
        $preorderLineMessage.value = variantPreorderMessage.split("Full")[0];
      } else {
        $preorderMessage.innerHTML = null;
        if ($preorderLineMessage) {
          $preorderLineMessage.value = null;
          $preorderLineMessage.remove();
        }
        $addToCartButton.innerHTML = "Add to cart";
      }
    } else {
      $preorderMessage.innerHTML = null;
      if ($preorderLineMessage) {
        $preorderLineMessage.value = null;
        $preorderLineMessage.remove();
      }
    }
  }

  backInStock() {
    var userEmail = document.querySelector('.BackInStock .input');
    var label = this.querySelector('.BackInStock .floating-label');
    if (userEmail && userEmail.value) {
      if (ValidateEmail(userEmail)) {
        this.subscribeUser(userEmail, label);
      } else {
        this.updateUIForInvalidEmail(label);
      }
    } else {
      this.updateUIForInvalidEmail(label);
    }
  }

  subscribeUser(userEmail, label) {
    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2024-07-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: userEmail.value
                }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + this.variantId + ''
              }
            }
          }
        }
      })
    };
    
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UtcaRi', options)
      .then(response => {
        if (response.status === 202) {
          this.updateUIForSuccess(label, userEmail);
        }
      })
      .catch(err => {
        this.updateUIForNetworkError(label);
      });
  }

  updateUIForSuccess(label, userEmail) {
    label.classList.add('subscribed');
    label.classList.remove('alert');
    userEmail.classList.add('subscribed');
    label.textContent = 'Subscribed: ' + this.variantTitle;
    this.querySelector('.notify-back').textContent = 'Subscribed';
  }

  updateUIForInvalidEmail(label) {
    label.classList.add('alert');
    label.classList.remove('subscribed');
    label.style.opacity = "1";
    label.textContent = 'Please enter a valid email';
  }

  updateUIForNetworkError(label) {
    label.classList.add('alert');
    label.textContent = 'Network error, try again later';
  }

}
if (!window.customElements.get("notify-preorder")) {
  window.customElements.define("notify-preorder", NotifyPreorder);
}

import { Drawer } from 'theme';

var RedirectPopup = class extends Drawer {
  async connectedCallback() {
    super.connectedCallback();
    if (sessionStorage.getItem("popupClosedForSession") === "true") return;

    await this.detectCountry(); // Wait for detectCountry to complete

    if (this.properStore) {
      this.showTimeout = setTimeout(() => this.show(), this.apparitionDelay);
    }

    this.removeEventListener('dialog:before-hide', this.handleClose); // Remove any existing listener
    this.addEventListener('dialog:before-hide', () => this.handleClose());
  }

  async detectCountry() {
    if (this.properStore) return; 
    try {
      const response = await fetch('https://' + window.location.hostname + '/browsing_context_suggestions.json');
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      this.data = await response.json();

      const redirectData = JSON.parse(document.querySelector('[data-redirects]').innerHTML);
      const redirect_list = redirectData.redirects;

      for (let redirect in redirect_list) {
        if (redirect_list.hasOwnProperty(redirect)) {
          const country_list = redirect_list[redirect].split(',');
          if (country_list.includes(this.data.detected_values.country.handle)) {
            this.properStore = true;

            const element = this.querySelector('.redirect_button .button');
            const redirect_flag = this.querySelector('.redirect_button a');
            const content = this.querySelector('.prose');
            const flagImage = this.querySelector('.redirect_button img');

            if (element) {
              element.innerHTML = element.textContent.replace('{country}', this.data.detected_values.country.handle);
              content.innerHTML = content.textContent.replace('{country}', this.data.detected_values.country_name);
              redirect_flag.href = redirect + window.location.pathname + window.location.search; 
              element.href = redirect + window.location.pathname + window.location.search;
            }
            if (flagImage) {
              const countryCode = this.data.detected_values.country.handle.toLowerCase();
              flagImage.src = `//cdn.shopify.com/static/images/flags/${countryCode}.svg?format=jpg&width=200`;
              flagImage.srcset = `//cdn.shopify.com/static/images/flags/${countryCode}.svg?format=jpg&width=200`;
              flagImage.alt = `${this.data.detected_values.country_name} Flag`;
            }
            return;  // Stop further processing once a match is found
          } else {
            this.properStore = false;
          }
        }
      }
    } catch (error) {
      console.error('There has been a problem with your fetch operation:', error);
    }
  }

  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }

  handleClose() {
    sessionStorage.setItem("popupClosedForSession", "true");
    if (this.showTimeout) {
      clearTimeout(this.showTimeout); // Prevent delayed show
      this.showTimeout = null;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:redirect-popup-appeared", "true");
    }
  }
};

if (!window.customElements.get("redirect-popup")) {
  window.customElements.define("redirect-popup", RedirectPopup);
}




// js/common/facets/facets-sort-popover.js
var FacetsSortInline = class extends HTMLElement {
  constructor() {
    super();
  }
 connectedCallback() {
  this.querySelectorAll('input').forEach(sort_input => {
    sort_input.addEventListener('change', (event) => {
      this.onSortChanged(event);
    });
  });
 }
 onSortChanged(event) {
  const url = new URL(window.location.href);
  url.searchParams.set("sort_by", event.target.value);
  url.searchParams.delete("page");
  url.searchParams.set("section_id", this.getAttribute("section-id"));
  this.dispatchEvent(new CustomEvent("facet:update", {
    bubbles: true,
    detail: {
      url
    }
  }));
}
};
if (!window.customElements.get("facets-sort-inline")) {
  window.customElements.define("facets-sort-inline", FacetsSortInline);
}

 


document.addEventListener('DOMContentLoaded', function() {
  var availabilityElement = document.querySelector('#facets-sidebar-filter\\.v\\.availability');
  if (availabilityElement) {
      availabilityElement.click();
  }
});

document.addEventListener('dialog:before-show', function() {
  var availabilityElement = document.querySelector('#facets-sidebar-filter\\.v\\.availability');
  if (availabilityElement) {
      availabilityElement.click();
  }
});



/**
 * Cart Discount Component for Prestige Theme
 * Handles applying and removing discount codes in the cart.
 */
class CartDiscountComponent extends HTMLElement {
  constructor() {
    super();
    this.applyDiscount = this.applyDiscount.bind(this);
    this.removeDiscount = this.removeDiscount.bind(this);
    this.abortController = null;
  }

  connectedCallback() {
    console.log(this);

    const form = this.querySelector('form[data-cart-discount]');
    if (form) {
      form.addEventListener('submit', this.applyDiscount);
    }
    this.querySelectorAll('.cart-discount__pill').forEach(pill => {
      pill.addEventListener('click', this.removeDiscount);
      pill.addEventListener('keydown', this.removeDiscount);
    });
  }

  disconnectedCallback() {
    const form = this.querySelector('form[data-cart-discount]');
    if (form) {
      form.removeEventListener('submit', this.applyDiscount);
    }
    this.querySelectorAll('.cart-discount__pill').forEach(pill => {
      pill.removeEventListener('click', this.removeDiscount);
      pill.removeEventListener('keydown', this.removeDiscount);
    });
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get errorContainer() {
    return this.querySelector('.cart-discount__error');
  }

  get errorDiscount() {
    return this.querySelector('.cart-discount__error--discount');
  }

  get errorShipping() {
    return this.querySelector('.cart-discount__error--shipping');
  }

  get discountInput() {
    return this.querySelector('input[name="discount"]');
  }

  get existingDiscounts() {
    return Array.from(this.querySelectorAll('.cart-discount__pill'))
      .map(pill => pill.dataset.discountCode)
      .filter(Boolean);
  }

  abortActiveFetch() {
    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();
    return this.abortController;
  }

  async applyDiscount(event) {
    console.log(event);
    event.preventDefault();
    event.stopPropagation();

    const discountCode = this.discountInput?.value?.trim();
    if (!discountCode || !this.sectionId) return;

    if (this.existingDiscounts.includes(discountCode)) return;

    this.hideErrors();

    const abortController = this.abortActiveFetch();
    console.log('Applying discount:', discountCode, 'Section ID:', this.sectionId);
    console.log('Existing discounts:', this.existingDiscounts);
    console.log('Abort controller:', abortController);
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          discount: [...this.existingDiscounts, discountCode].join(','),
          sections: [this.sectionId]
        }),
        signal: abortController.signal
      });

      const data = await response.json(); 

      // Check for invalid discount
      if (
        data.discount_codes &&
        data.discount_codes.some(
          d => d.code === discountCode && d.applicable === false
        )
      ) {
        this.discountInput.value = '';
        this.showError('discount');
        return;
      }

      // Check for shipping discount error
      const parser = new DOMParser();
      const html = data.sections[this.sectionId];
      const doc = parser.parseFromString(html, 'text/html');
      const pills = doc.querySelectorAll('.cart-discount__pill');
      const codes = Array.from(pills)
        .map(el => el.dataset.discountCode)
        .filter(Boolean);
      if (
        codes.length === this.existingDiscounts.length &&
        codes.every(code => this.existingDiscounts.includes(code)) &&
        data.discount_codes &&
        data.discount_codes.some(
          d => d.code === discountCode && d.applicable === true
        )
      ) {
        this.showError('shipping');
        this.discountInput.value = '';
        return;
      }

      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (e) {
      console.error('Error applying discount:', e);
      // Optionally handle error
    } finally {
      this.abortController = null;
    }
  }

  async removeDiscount(event) {
    if (
      (event instanceof KeyboardEvent && event.key !== 'Enter') ||
      !(event instanceof MouseEvent || event instanceof KeyboardEvent)
    ) {
      return;
    }

    const pill = event.target.closest('.cart-discount__pill');
    if (!pill) return;

    const code = pill.dataset.discountCode;
    if (!code) return;

    const discounts = this.existingDiscounts.filter(d => d !== code);

    const abortController = this.abortActiveFetch();

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          discount: discounts.join(','),
          sections: [this.sectionId]
        }),
        signal: abortController.signal
      });

      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (e) {
      // Optionally handle error
    } finally {
      this.abortController = null;
    }
  }

  showError(type) {
    if (this.errorContainer) this.errorContainer.classList.remove('hidden');
    if (type === 'discount' && this.errorDiscount) this.errorDiscount.classList.remove('hidden');
    if (type === 'shipping' && this.errorShipping) this.errorShipping.classList.remove('hidden');
  }

  hideErrors() {
    if (this.errorContainer) this.errorContainer.classList.add('hidden');
    if (this.errorDiscount) this.errorDiscount.classList.add('hidden');
    if (this.errorShipping) this.errorShipping.classList.add('hidden');
  }

  replaceSection(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const section = doc.getElementById(`shopify-section-${this.sectionId}`);
    if (section) {
      const currentSection = document.getElementById(`shopify-section-${this.sectionId}`);
      if (currentSection) {
        currentSection.replaceWith(section);
      }
    }
  }
}

if (!customElements.get('cart-discount-component')) {
  customElements.define('cart-discount-component', CartDiscountComponent);
}
